import React from 'react'
import { WebsiteLinkActionButtonEntityInterface } from 'src/shared/entities/button/website-link.action-button.schema'
import { BasePublisherLinkButton } from '../base-publisher-link-button'

// intentionally repeats open url button
const TEST_ID = 'open-url-button'

export interface WebsiteLinkButtonProps {
  entity: WebsiteLinkActionButtonEntityInterface
}

export const WebsiteLinkButton = ({ entity }: WebsiteLinkButtonProps) => {
  return (
    <BasePublisherLinkButton
      entity={entity}
      dataTestId={TEST_ID}
      href={entity.websiteLink}
      rel={entity.rel}
      target={entity.linkTarget}
    />
  )
}
